// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as Turbo from "@hotwired/turbo"
import "./controllers"

// Custom confirm dialog for Turbo
Turbo.setConfirmMethod((message, element) => {
  return new Promise((resolve) => {
    const dialog = document.getElementById("confirm-dialog")
    if (!dialog) {
      // Fallback to native confirm if dialog not found
      resolve(window.confirm(message))
      return
    }

    const controller = window.Stimulus.getControllerForElementAndIdentifier(dialog, "confirm-dialog")
    if (!controller) {
      resolve(window.confirm(message))
      return
    }

    // Parse options from data attributes if present
    const options = {
      title: element?.dataset?.confirmTitle || "Confirm Delete",
      confirmText: element?.dataset?.confirmButton || "Delete",
      cancelText: element?.dataset?.cancelButton || "Cancel",
      destructive: element?.dataset?.confirmDestructive !== "false"
    }

    controller.show(message, options).then(resolve)
  })
})

import "trix"
import "@rails/actiontext"
